// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21uN1","col":"styles_col__xQTFJ"};